import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoPessoaTipoMultiselectComponent } from './novo-pessoa-tipo-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoPessoaTipoMultiselectComponent],
  exports: [NovoPessoaTipoMultiselectComponent]
})
export class NovoPessoaTipoMultiselectModule {}
